<div class="container-form-page">
  <form [formGroup]="containerForm">
    <mat-card>
      <mat-card-content style="text-align: end;">
        <mat-hint style="color: red;">{{status}}</mat-hint>
        @if (showDeactivateToggle && this.contId.value) {
          <mat-slide-toggle (change)="openDeactivateForm()" [(ngModel)]="checked"
            [ngModelOptions]="{standalone: true}">
          Deactivate Container</mat-slide-toggle>
        }
        @if (showReactivateToggle && this.contId.value) {
          <mat-slide-toggle (change)="openReactivateForm()" [(ngModel)]="checked"
            [ngModelOptions]="{standalone: true}">
          Reactivate Container</mat-slide-toggle>
        }
      </mat-card-content>
      <mat-card-content>
        <h4>{{contId.value ? 'Edit' : 'New'}} Container</h4>
        <mat-form-field appearance="fill">
          <mat-label>Container Size</mat-label>
          <mat-select formControlName="sizeId" placeholder="Select Container Size" required>
            <mat-option>
              <ngx-mat-select-search  [searching]="searching"
                noEntriesFoundLabel="'no matching found'" placeholderLabel="Find Container size" [formControl]="containerSearchCtrl">
                <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
              </ngx-mat-select-search>
            </mat-option>
            <mat-option [value]="null">None</mat-option>
            @for (item of filteredContainer | async; track item) {
              <mat-option [value]="item.id">
                {{item.size}}
              </mat-option>
            }
          </mat-select>
          @if (sizeId.touched && sizeId.invalid && sizeId.hasError('required')) {
            <mat-error>Container Size is Required</mat-error>
          }
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>Equipment Code</mat-label>
          <mat-select formControlName="equipmentTypeId" placeholder="Select Equipment Type" required>
            <mat-select-trigger>
              {{getEquipmentTypeCode(equipmentTypeId.value)}}
            </mat-select-trigger>
            <mat-option>
              <ngx-mat-select-search  [searching]="searching"
                noEntriesFoundLabel="'no matching found'" placeholderLabel="Find Equipment" [formControl]="equipmentSearchCtrl">
                <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
              </ngx-mat-select-search>
            </mat-option>
            <mat-option [value]="null">None</mat-option>
            @for (type of filteredEquipment | async; track type) {
              <mat-option [value]="type.id">
                <div style="overflow:auto;">
                  <table mat-table>
                    <ng-container matColumnDef="code">
                      <th mat-header-cell *matHeaderCellDef> {{type.code}} </th>
                    </ng-container>
                    <ng-container matColumnDef="name">
                      <th mat-header-cell *matHeaderCellDef> {{type.name}} </th>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="copyCartingEntryColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: copyCartingEntryColumns"></tr>
                  </table>
                </div>
                <!-- {{type.code}} -->
              </mat-option>
            }
          </mat-select>
          @if (equipmentTypeId.touched && equipmentTypeId.invalid && equipmentTypeId.hasError('required')) {
            <mat-error>Container Size is Required</mat-error>
          }
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>Container Name</mat-label>
          <input matInput formControlName="name" readonly>
          @if (name.touched && name.invalid && name.hasError('required')) {
            <mat-error>Container Name is Required</mat-error>
          }
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>Number of TEU</mat-label>
          <input matInput formControlName="noOfTeu" readonly>
          @if (noOfTeu.touched && noOfTeu.invalid && noOfTeu.hasError('required')) {
            <mat-error>No. of TEU is Required</mat-error>
          }
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>Special Equipment</mat-label>
          <input matInput formControlName="specialEquipment" readonly>
          @if (specialEquipment.touched && specialEquipment.invalid && specialEquipment.hasError('required')) {
            <mat-error>Special Equipment is Required</mat-error>
          }
        </mat-form-field>
      </mat-card-content>
      <mat-card-actions>
        <button mat-button color="primary" (click)="onSave()" [disabled]=" (status==='Deactivated...')||(!editPermission && contId.value) || (!addPermission && !contId.value)">Save</button>
        <button mat-button color="cancel" (click)="onCancel()">Cancel</button>
      </mat-card-actions>
    </mat-card>
  </form>
</div>
